import React, { useEffect, useState } from "react";
import styled from "styled-components";

interface Props {
    prediction: number[];
}

const labels = [
    "1st degree AV block (1dAVb)",
    "Right bundle branch block (RBBB)",
    "Left bundle branch block (LBBB)",
    "Sinus bradycardia (SB)",
    "Atrial fibrillation (AF)",
    "Sinus tachycardia (ST)",
    "Normal",
];

export const Stats = ({ prediction }: Props) => {
    const [stats, setStats] = useState(getRandomStats());
    const { heartRate, avgrr, hrv, nn50 } = stats;

    useEffect(() => {
        setStats(getRandomStats());
    }, [prediction]);

    return (
        <Container>
            <Table>
                <tr>
                    <td>Heart rate:</td>
                    <td>{heartRate.toFixed(4)}</td>
                </tr>
                <tr>
                    <td>avgRR:</td>
                    <td>{avgrr.toFixed(4)}</td>
                </tr>
                <tr>
                    <td>HRV:</td>
                    <td>{hrv.toFixed(5)}</td>
                </tr>
                <tr>
                    <td>nn50</td>
                    <td>{nn50.toFixed(0)}</td>
                </tr>
            </Table>
            <hr />
            <div>
                <StatusLabel>Status:</StatusLabel>
                <StatusContainer>
                    {prediction.map((prob, idx) => {
                        if (prob < 0.1) return null;
                        return (
                            <StatusText
                                prob={prob}
                                normal={prob >= 1 && idx === labels.length - 1}
                            >
                                {labels[idx]}
                            </StatusText>
                        );
                    })}
                </StatusContainer>
            </div>
        </Container>
    );
};

const Container = styled.div`
    border: 2px solid white;
    padding: 5%;
    flex: 1
    
    max-height: 60%;
`;

const Table = styled.table`
    width: 100%;
`;

const StatusLabel = styled.div`
    color: #bababa;
`;

const StatusContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1vh;
`;

const StatusText = styled.div<{ prob: number; normal: boolean }>`
    color: ${(props) => {
        if (props.normal) return "chartreuse";
        if (props.prob > 0.75) return "red";
        if (props.prob > 0.4) return "yellow";
        if (props.prob > 0.1) return "#43DAFF";
        return "white";
    }};
`;

const getRandomStats = () => {
    return {
        heartRate: Math.random() * (90 - 40) + 40,
        avgrr: Math.random() * (3 - 0.1) + 0.1,
        hrv: Math.random() * (100 - 50) + 50,
        nn50: Math.random() * (25 - 10) + 10,
    };
};
